import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { SmartBuilderRoute } from "@/components/auth/AppRoutePages";
export const Route = createFileRoute("/builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><SmartBuilderRoute /></ProtectedRoute>) });
